<template>
  <div>
    <h4 v-translate>Povolené parametry obrázku:</h4>
    <ul>
      <li v-if="constraint.min_width" :style="{ color: textColor(image_validity.min_width) }"><strong
          v-translate>Minimální šířka:</strong> {{ constraint.min_width }}px
      </li>
      <li v-if="constraint.max_width" :style="{ color: textColor(image_validity.max_width) }"><strong
          v-translate>Maximální šířka:</strong> {{ constraint.max_width }}px
      </li>
      <li v-if="constraint.min_height" :style="{ color: textColor(image_validity.min_height) }"><strong
          v-translate>Minimální výška:</strong> {{ constraint.min_height }}px
      </li>
      <li v-if="constraint.max_height" :style="{ color: textColor(image_validity.max_height) }"><strong
          v-translate>Maximální výška:</strong> {{ constraint.max_height }}px
      </li>
      <li v-if="constraint.width_ratio" :style="{ color: textColor(image_validity.width_ratio) }"><strong
          v-translate>Pomeř stran (š/v):</strong> {{ constraint.width_ratio }}
      </li>
      <li v-if="constraint.max_kb" :style="{ color: textColor(image_validity.max_kb) }"><strong v-translate>Maximální velikost souboru:</strong> {{ constraint.max_kb }}kB
      </li>
      <li v-if="constraint.mime_types" :style="{ color: textColor(image_validity.mime_types) }"><strong
          v-translate>Povolené typy:</strong> {{ constraint.mime_types.join(', ') }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Constraints",
  props: {
    constraint: Object,
    image_validity: Object,
  },
  methods: {
    textColor(value) {
      if (value === null) {
        return 'black';
      } else if (value === true) {
        return 'green';
      } else {
        return 'red';
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/images/forms/Constraints.vue